<template>
  <form class="position-relative" @submit.prevent="submit">
    <div class="vuedl-layout__closeBtn" @click="close(true)">
      ×
    </div>
    <v-card>
      <v-card-title class="headline grey lighten-2 mb-4 justify-center" primary-title>
        Редактирование {{ type.name }}
      </v-card-title>

      <v-card-text>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Названия
                </th>
                <th class="text-left">
                  Заболевание
                </th>
                <th class="text-left">
                  Когда?
                </th>
                <th class="text-center">
                  Критичность
                </th>
                <th class="text-center">
                  <div>Ограничить сбор</div>
                </th>
                <th class="text-center">
                  Начало задания
                </th>
                <th class="text-center">
                  Конец задания
                </th>
                <th class="text-center">
                  Пожизненно?
                </th>
              </tr>
            </thead>
            <tbody>
              <component v-bind:is="'TaskItemRow'" :edit-mode="true" :form="value" :type="type" />
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>

      <v-card-text>
        <v-textarea label="Введите комментарий к задаче" dense v-model="value.comment"></v-textarea>
      </v-card-text>

      <v-card-actions>
        <v-btn type="submit" color="primary" text>Обновить</v-btn>
        <v-spacer></v-spacer>
        <v-btn type="button" color="primary" text @click="deleteTask">Удалить</v-btn>
        <v-spacer></v-spacer>
        <v-btn type="button" color="primary" text @click="$emit('submit')">Закрыть</v-btn>
      </v-card-actions>
    </v-card>
  </form>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { messageHelper } from "@/services/validation-helper.js";
import DynamicForm from "@/modules/documents/add-document/DynamicForm.vue";

import Pps from "@/views/pages/tasks/components/Pps.vue";
import Measure from "@/views/pages/tasks/components/Measure.vue";
import DatePicker from "@/components/forms/DatePicker.vue";
import TimePicker from "@/components/forms/TimePicker.vue";
import AutocompleteMedParams from "@/components/AutocompleteMedParams.vue";
import { TasksRepository } from "@/modules/tasks/tasks.repository.js";
import PatientDiseasesList from "@/components/PatientDiseasesList.vue";
import TaskItemRow from "@/views/pages/tasks/components/TaskItemRow.vue";
import { formModal } from "@/mixins/modal/form-modal.js";

/**
 * Редактирует задание в группе(типе)
 */
export default {
  name: "EditTaskItem",
  mixins: [formModal],
  components: { PatientDiseasesList, AutocompleteMedParams, DynamicForm, Pps, Measure, DatePicker, TimePicker, TaskItemRow },

  props: {
    type: {
      type: Object,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },

  data() {
    /**
     * @property {TaskScheduledEvent} value
     */
    return {
      value: null,
      durationList: [],
      periodicityList: [],
    };
  },

  validations: {
    form: {
      category: { required },
    },
  },

  computed: {
    typeErrors() {
      return messageHelper(this.$v.form.category);
    },
  },

  async created() {
    this.value = { ...this.item };
    await Promise.all([this.loadDurationList(), this.loadPeriodicityList()]);
  },

  methods: {
    async loadDurationList() {
      try {
        this.durationList = await TasksRepository.duration();
      } catch (e) {
        console.error(e);
        this.$dialog.notify.error("Ошибка загрузки списка 'длительности периодов'");
      }
    },

    async loadPeriodicityList() {
      try {
        this.periodicityList = await TasksRepository.periodicity();
      } catch (e) {
        console.error(e);
        this.$dialog.notify.error("Ошибка загрузки списка 'переодичностей'");
      }
    },

    async deleteTask() {
      this.value.endAt = this.$date().format("YYYY-MM-DD");
      await this.submit();
    },

    async submit() {
      // this.$v.form.$touch();
      // if (this.$v.form.$pending || this.$v.form.$error) return;

      if (this.value.entity) {
        this.value.name = this.value.entity.name;
        this.value.entityId = this.value.entity.id;
      }

      this.value.finished = this.$date().isSame(this.$date(this.value.endAt), "day");
      const payload = {
        title: this.value.name,
        diseases: [],
        fields: {
          critical: this.value.critical,
          limited: this.value.limited,
          lifelong: this.value.lifelong,
        },
      };

      if (this.value.diseases) {
        payload.diseases.push(this.value.diseases);
      }

      // Формируем объект обновления данных для API
      const data = {
        entity_payload: JSON.stringify(payload),
        event_periodicity_id: this.value.periodicity?.id || null,
        event_duration_id: null,
        factor: this.value.factor,
        order: this.value.order,
        end_at: this.value.endAt,
        datetimes: JSON.stringify(this.value.datetimes),
        comment: this.value.comment,
      };

      try {
        const result = await TasksRepository.update(this.$store.state.customer.id, this.value.id, data);

        if (!result.success) {
          this.$dialog.notify.error(`Ошибка обновления задачи "${this.value.name}"`);
          return;
        }
      } catch (e) {
        this.$dialog.notify.error(`Ошибка обновления задачи "${this.value.name}"`);
        return;
      }

      this.$dialog.notify.success(`Задача "${this.value.name}" обновлена`);
      this.$emit("submit", { ...this.value });
    },
  },
};
</script>

<style scoped></style>
